export enum StoryCharacterAgeUnitEnum {
  year = 'year',
  month = 'month',
}

export enum StoryCharacterEnum {
  human = 'human',
  animal = 'animal',
  fictional = 'fictional',
}

export enum StoryCharacterGenderEnum {
  girl = 'girl',
  boy = 'boy',
}

export interface CharacterModel {
  artStyle?: string;
  characterId?: string;
  characterName?: string;
  characterUrl?: string;
  timestamp?: Date;
  age?: number;
  ageUnit: StoryCharacterAgeUnitEnum;
  mics?: string;
  gender?: StoryCharacterGenderEnum;
  animalType?: StoryCharacterEnum;
  characterType?: StoryCharacterEnum;
  character?: string;
  name?: string;

  skinTone?: string;
  hairColor?: string;
  hairStyle?: string;
  eyeColor?: string;
  wearsUses?: string;
  otherFeatures?: string;
}